export const SET_DAYS = 'SET_DAYS'
export const SET_STATUS = 'SET_STATUS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_SELECTED = 'SET_SELECTED'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_CONTACT = 'SET_CONTACT'
export const SET_CONTACTS = 'SET_CONTACTS'
export const SET_CONTACTS_FOUND = 'SET_CONTACTS_FOUND'
export const SET_ADDRESSES_FOUND = 'SET_ADDRESSES_FOUND'
export const SET_PHONES_FOUND = 'SET_PHONES_FOUND'
export const SET_BIRTHDAYS_FOUND = 'SET_BIRTHDAYS_FOUND'
export const SET_CONTACT_ADDRESS = 'SET_CONTACT_ADDRESS'
export const SET_CONTACT_ADDRESSES = 'SET_CONTACT_ADDRESSES'
export const SET_CONTACT_PHONES = 'SET_CONTACT_PHONES'
export const SET_CONTACT_EMAILS = 'SET_CONTACT_EMAILS'
export const SAVE_ADDRESS = 'SAVE_ADDRESS'
export const DELETE_ADDRESS = 'DELETE_ADDRESS'
export const SET_PRIMARY_ADDRESS = 'SET_PRIMARY_ADDRESS'
export const SET_CHECKED_ADDRESS = 'SET_CHECKED_ADDRESS'
export const SAVE_PHONE = 'SAVE_PHONE'
export const DELETE_PHONE = 'DELETE_PHONE'
export const SET_PRIMARY_PHONE = 'SET_PRIMARY_PHONE'
export const SET_CHECKED_PHONE = 'SET_CHECKED_PHONE'
export const SAVE_EMAIL = 'SAVE_EMAIL'
export const DELETE_EMAIL = 'DELETE_EMAIL'
export const SET_PRIMARY_EMAIL = 'SET_PRIMARY_EMAIL'
export const SET_CHECKED_EMAIL = 'SET_CHECKED_EMAIL'
export const SET_CONTACT_CHECKED = 'SET_CONTACT_CHECKED'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const ADD_CONTACT = 'ADD_CONTACT'
export const SET_CONTACT_INCOME = 'SET_CONTACT_INCOME'
export const SET_CHECKED_INCOME = 'SET_CHECKED_INCOME'
export const REFRESH_CONTACT_INCOME_CHECKED = 'REFRESH_CONTACT_INCOME_CHECKED'
export const SET_CONTACT_EXPENSES = 'SET_CONTACT_EXPENSES'
export const SET_CHECKED_EXPENSE = 'SET_CHECKED_EXPENSE'
export const REFRESH_CONTACT_EXPENSES_CHECKED = 'REFRESH_CONTACT_EXPENSES_CHECKED'
export const RESET_VISIT_CONTACT = 'RESET_VISIT_CONTACT'
export const SET_RELATED = 'SET_RELATED'

export const CONTACT_ORDER_BY = 'contact/orderBy'
export const CONTACT_SORT_DIR = 'contact/sortDir'
export const CONTACT_DAYS = 'contact/days'
export const CONTACT_STATUS = 'contact/status'
export const CONTACT_PAGE_SIZE = 'contact/pageSize'
export const CONTACT_SEARCH_TERM = 'contact/searchTerm'
export const CONTACT_FILTER_BY = 'contact/filterBy'

export const SET_ITEM = 'SET_ITEM'
export const ADD_ADDRESS = 'ADD_ADDRESS'
export const REMOVE_ADDRESS = 'REMOVE_ADDRESS'
export const ADD_PHONE = 'ADD_PHONE'
export const REMOVE_PHONE = 'REMOVE_PHONE'
export const ADD_EMAIL = 'ADD_EMAIL'
export const REMOVE_EMAIL = 'REMOVE_EMAIL'



// WEBPACK FOOTER //
// ./src/store/modules/contacts/types.js